export function capitalizeString(value: string) {
  if (!value) {
    return null;
  }
  const valueArray = value.split(' ');
  return valueArray
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');
}
